import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class OvertimeRequestHelper  {
    _originalTypeClassName = "zSHR.BO.OvertimeRequestHelper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OvertimeRequestHelper.translate = translateService;
}
this.OvertimeRequestHelperKey = null;
this._key = this.OvertimeRequestHelperKey = 0; 
}

static translate: TranslateService;
_key: any;
private _OvertimeRequestHelperKey:any;
get OvertimeRequestHelperKey(): any {
    return this._OvertimeRequestHelperKey;
  }
set OvertimeRequestHelperKey(value: any) {
    this._OvertimeRequestHelperKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.OvertimeRequestHelperKey == null || $this.OvertimeRequestHelperKey == 0;
            }


}